export const environment = {
  production: true,
  debug: false,
  /**
   * @deprecated Используйте `apiBaseUrl`.
   */
  apiServer: "https://v2.tacoma.cloud/api",
  /**
   * @deprecated Используйте `authBaseUrl`.
   */
  identityServer: "https://v2.tacoma.cloud/identity",
  apiBaseUrl: "https://v2.tacoma.cloud/api",
  authBaseUrl: "https://v2.tacoma.cloud/identity",
  authHeaderClient: "Basic dGFrb21hY2xpZW50OnNlY3JldA==",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts